export default {
  SET_MONITORING_LIST(state, monitoringList) {
    state.monitoringList = monitoringList;
  },
  SET_MONITORING_STATUS(state, monitoringStatus) {
    state.monitoringStatus = monitoringStatus;
  },
  SET_MONITORING_INFO(state, monitoringInfo) {
    sessionStorage.setItem('monitoringInfo', JSON.stringify(monitoringInfo));
    state.monitoringInfo = monitoringInfo;
  },
  RESET_MONITORING_INFO(state) {
    sessionStorage.removeItem('monitoringInfo');
    state.monitoringInfo = {};
  },
  SET_MONITORED_LIST(state, monitoredList) {
    state.monitoredList = monitoredList;
  },
  RESET_MONITORED_LIST(state) {
    state.monitoredList = {
      list: [],
      count: 0,
    };
  },
  SET_MONITORED_NOTICE(state, monitoredNotice) {
    state.monitoredNotice = monitoredNotice;
  },
  RESET_MONITORED_NOTICE(state) {
    state.monitoredNotice = {
      list: [],
      count: 0,
    };
  },
};